export default __webpack_public_path__ + "static/media/back.17c68712.png";